import React, { useState } from 'react';

const ALL_REGIONS = [
  'af-south-1', 'ap-northeast-1', 'ap-northeast-2', 'ap-northeast-3',
  'ap-south-1', 'ap-south-2', 'ap-southeast-1', 'ap-southeast-2', 
  'ap-southeast-3', 'ap-southeast-4', 'ca-central-1', 'eu-central-1',
  'eu-central-2', 'eu-north-1', 'eu-south-1', 'eu-south-2',
  'eu-west-1', 'eu-west-2', 'eu-west-3', 'me-central-1', 
  'me-south-1', 'sa-east-1', 'us-east-1', 'us-east-2', 
  'us-west-1', 'us-west-2'
];

function APIDocumentation() {
  const [showUrls, setShowUrls] = useState(false);

  const toggleUrls = () => {
    setShowUrls(!showUrls);
  };

  return (
    <div className="api-documentation-simple">
      <div className="api-section">
        <h2>LayerAPI</h2>
        <p><strong>Version:</strong> 2019-02-08T01:20:23Z</p>
        <a href="/LayerAPI-prod-oas30.yaml" className="download-link" download>
          Download OpenAPI definition
        </a>
        
        <div className="api-endpoint">
          <div className="endpoint-header" onClick={toggleUrls}>
            <span className="method-get">GET</span>
            <span className="endpoint-path">/get-layers</span>
            <button className="expand-btn">
              {showUrls ? '▼' : '▶'}
            </button>
          </div>
          
          {showUrls && (
            <div className="api-urls-popup">
              {ALL_REGIONS.map(region => (
                <div key={region} className="selectable-url">
                  https://{region}.layers.newrelic-external.com/get-layers
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default APIDocumentation;
